<template>
    <div class="container">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="user_key管理" name="userKey">
            </el-tab-pane>
            <el-tab-pane label="活跃用户" name="activedUser">
            </el-tab-pane>
            <el-tab-pane :disabled="true" label="调用记录" name="apiRecords">
            </el-tab-pane>
            <el-tab-pane :disabled="true" label="连接记录" name="connectionRecords">
            </el-tab-pane>
            <router-view v-if="!$route.meta.keepAlive1"></router-view>
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive1"></router-view>
            </keep-alive>
        </el-tabs>
    </div>
</template>
<script>
  import {mapGetters, mapActions, mapMutations} from "vuex";
  import vvTable from "vue-virtual-table";
  import {
    apiGetConnectionRecord,
    apiGetApiCount,
    apiGetAvailableKey,
    apiAddNewUserKey,
    apiDeleteUserKey
  } from "@/api";
  import moment from "moment";
  import _ from "lodash";

  export default {
    name: "ffi",
    components: {
      vvTable
    },
    data() {
      return {
        loading: false,
        connectionLoading: false,
        user_keys: [],
        user_key_list: [],
        currentKey: "",
        connectionTotal: 0,
        connectionList: [],
        activeName: "userKey"
      };
    },
    mounted() {
      this.setSubTitle('user_key管理');
      this.handleClick({name: this.activeName})
    },

    methods: {
      ...mapMutations(['setSubTitle']),
      handleClick({name}) {
        this.$router.push({
          name
        })
      },
      viewConnectionList(key) {
        this.activeName = 'connection';
        this.currentKey = key;
      },
      async getConnectionRecord() {
        try {
          this.connectionLoading = true;
          const res = await apiGetConnectionRecord({
            user_key: this.user_key,
            page_num: 1,
            per_page: 20
          });
          // console.log(res);
          this.connectionList = res.page_list;
          this.connectionLoading = false;
          // this.connectionList = [
          //   {"id": 1, "user_key": "sedexo1", "ip": "41.28.66.166", "port": 56166, "addts": 15105265420, "delts": 15105275655}
          // ];
          this.connectionTotal = res.total;
        } catch (e) {
          console.log(e);
          this.connectionLoading = false;
        }
      },
      totalCount(countObj) {
        if (!countObj) {
          return 0;
        } else {
          return _.reduce(
            Object.values(countObj),
            (sum, count) => {
              return sum + count;
            },
            0
          );
        }
      }
    },
    computed: {
      ...mapGetters([]),
      dateRangeTs() {
        let [start_time, end_time] = this.dateRange
        start_time = moment(start_time).startOf('day').unix()
        end_time = moment(end_time).add(1, "day").startOf('day').unix()
        return {
          start_time,
          end_time
        }
      },

      tableConfig() {
        return [
          {prop: "id", name: "#", width: 50},
          {prop: "user_key", name: "user_key", width: 100},
          {prop: "ip", name: "ip", width: 150},
          {prop: "port", name: "端口", width: 50},
          {prop: "_action", name: "连接时间", width: 150, actionName: "addTs"},
          {prop: "_action", name: "断开时间", width: 150, actionName: "delTs"},
          {
            prop: "_action",
            name: "持续时间(s)",
            width: 150,
            actionName: "durationTime"
          }
        ];
      }
    },
    filters: {
      tsToDate(ts) {
        return moment(ts * 1000).format("YYYY-MM-DD hh:mm:ss");
      }
    },
    watch: {
      currentKey() {
        this.getConnectionRecord();
      },
      '$route.name'(val) {
        console.log(val);
        this.activeName = val
      }
    }
  };
</script>
<style></style>
